// Textos externalizados (RNF-ADM-06). Estilo gettext: o texto em pt-BR é a chave, então todo
// texto da interface passa por t() e pode ser extraído; outros idiomas ficam em dicionários.
// pt-BR é o padrão; en-US cobre a navegação e as ações comuns e cai no pt-BR no restante.

const enUS: Record<string, string> = {
  "Início": "Home",
  "Resumo": "Overview",
  "Métricas do gateway no período escolhido.": "Gateway metrics for the selected period.",
  "Ao longo do período": "Over the period",
  "Tenants": "Tenants",
  "Aprovações": "Approvals",
  "Modelos": "Models",
  "Aliases": "Aliases",
  "Políticas": "Policies",
  "Ferramentas MCP": "MCP tools",
  "Custos": "Costs",
  "Auditoria e logs": "Audit & logs",
  "Observabilidade": "Observability",
  "Dashboard": "Dashboard",
  "Admin API (Swagger)": "Admin API (Swagger)",
  "Plataforma": "Platform",
  "Economia de tokens": "Token savings",
  "Governança de IA": "AI Governance",
  "Sair": "Sign out",
  "Salvar": "Save",
  "Cancelar": "Cancel",
  "Publicar": "Publish",
  "Criar": "Create",
  "Editar": "Edit",
  "Remover": "Remove",
  "Buscar": "Search",
  "Filtros salvos": "Saved filters",
  "Salvar filtro": "Save filter",
  "Todos os tenants": "All tenants",
  "Carregando": "Loading",
  "Aprovar": "Approve",
  "Recusar": "Reject",
  "Pedir ajuste": "Request changes",
  "Revogar": "Revoke",
  "Rotacionar": "Rotate",
  "Emitir chave": "Issue key",
  "Rollback": "Rollback",
  "Tentar de novo": "Try again",
  "Pular para o conteúdo": "Skip to content",
  "Sua sessão vai expirar por inatividade": "Your session is about to expire due to inactivity",
  "Continuar conectado": "Stay signed in",
  "Confirme sua identidade para continuar": "Confirm your identity to continue",
  "Somente leitura: gerido por Git": "Read-only: managed by Git",
  "Propor mudança": "Propose change",
  "Ambiente": "Environment",
  "Período": "Period",
  "Última hora": "Last hour",
  "Últimas 24 horas": "Last 24 hours",
  "Últimos 7 dias": "Last 7 days",
  "Últimos 30 dias": "Last 30 days",
  "Degradação em andamento": "Ongoing degradation",
  "Tema": "Theme",
  "Claro": "Light",
  "Escuro": "Dark",
  "Grafite": "Graphite",
  "Idioma": "Language",
  "Nova solicitação": "New request",
  "Fila": "Queue",
  "Fluxos de aprovação": "Approval flows",
  "Pendentes": "Pending",
  "Aguardando você": "Waiting on you",
  "Pedidas por você": "Requested by you",
  "Sua vez": "Your turn",
  "Pendente": "Pending",
  "Aprovada": "Approved",
  "Aplicada": "Applied",
  "Recusada": "Rejected",
  "Ajuste pedido": "Changes requested",
  "Expirada": "Expired",
  "Falhou": "Failed",
  "aprovou": "approved",
  "recusou": "rejected",
  "pediu ajuste": "requested changes",
  "prazo esgotado": "deadline passed",
  "{h} h para decidir": "{h} h to decide",
  "{m} min para decidir": "{m} min to decide",
  "{s} s para decidir": "{s} s to decide",
  "1 aprovação": "1 approval",
  "{n} aprovações": "{n} approvals",
  "{n} h": "{n} h",
  "automática abaixo de {n}": "auto-approve below {n}",
  "sem prazo": "no deadline",
  "Nada para decidir agora": "Nothing to decide right now",
  "Publicar MCP": "Publish MCP",
  "Chamada MCP": "MCP call",
  "Orçamento estourado": "Budget exceeded",
  "Entrar em projeto": "Join a project",
  "O que você quer pedir?": "What do you need?",
};

const dicts: Record<string, Record<string, string>> = { "pt-BR": {}, "en-US": enUS };

function initial(): string {
  try {
    const saved = localStorage.getItem("polaris:lang");
    if (saved && dicts[saved]) return saved;
  } catch {
    /* armazenamento indisponível */
  }
  return "pt-BR";
}

let lang = initial();

export function getLang() {
  return lang;
}

export function setLang(l: string) {
  if (!dicts[l]) return;
  lang = l;
  try {
    localStorage.setItem("polaris:lang", l);
  } catch {
    /* ok */
  }
  document.documentElement.lang = l;
}

/** Traduz e interpola {nome}. */
export function t(text: string, vars?: Record<string, string | number>): string {
  let out = dicts[lang]?.[text] ?? text;
  if (vars) for (const [k, v] of Object.entries(vars)) out = out.replaceAll(`{${k}}`, String(v));
  return out;
}

export const languages = [
  { id: "pt-BR", label: "Português (Brasil)", flag: "/flags/BRASIL.webp" },
  { id: "en-US", label: "English (US)", flag: "/flags/EUA.webp" },
];
